/* HuishoudVoordeel USP bar — clean, isolated, no reviews */
(function(){
  'use strict';
  try {
    var script = document.currentScript;
    var sectionId = script && script.getAttribute('data-hv-section');
    var root = sectionId ? document.querySelector('section[data-section-id="'+sectionId+'"]') : null;
    if(!root) return;

    var wrap  = root.querySelector('.hv-usp__wrap');
    if(!wrap) return;

    var items = Array.prototype.slice.call(wrap.querySelectorAll('.hv-usp__item'));
    if(!items.length) return;

    var isMobile = function(){ return window.matchMedia('(max-width:768px)').matches; };
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var idx = 0, timer = null, interval = 3500;

    function setActive(){
      if(isMobile()){
        items.forEach(function(el,n){ el.classList.toggle('is-active', n===idx); });
      } else {
        items.forEach(function(el){ el.classList.remove('is-active'); });
      }
    }

    function next(){ idx = (idx + 1) % items.length; setActive(); }
    function start(){
      if(prefersReducedMotion) return;
      if(!timer && isMobile()) timer = setInterval(next, interval);
    }
    function stop(){ if(timer){ clearInterval(timer); timer = null; } }
    function reset(){ stop(); start(); }

    // Swipe (Y-axis for stability)
    var startY = null, dy = 0;
    wrap.addEventListener('touchstart', function(e){ if(!isMobile()) return; startY = e.touches[0].clientY; stop(); }, {passive:true});
    wrap.addEventListener('touchmove',  function(e){ if(startY==null) return; dy = e.touches[0].clientY - startY; }, {passive:true});
    wrap.addEventListener('touchend',   function(){ if(!isMobile()) return;
      if(Math.abs(dy)>30){ idx = dy>0 ? (idx-1+items.length)%items.length : (idx+1)%items.length; setActive(); }
      startY=null; dy=0; start();
    });

    window.addEventListener('resize', function(){ setActive(); if(isMobile()) start(); else stop(); });

    // Init
    setActive(); if(isMobile()) start();

  } catch(e){
    console.warn('HV USP init skipped:', e);
  }
})();
